import "./Card.scss"

const Card = ({person}) =>{
    return(
        <div className="Card">
            <div className="Card-picture">
                <img src={person && person.pic} alt="UCU Space Robotics team member"/>
            </div>
            <div className="Card-description">
                <h5>{person && person.name}</h5>
                <p className="Card-description-p">
                    {person && person.workplace && person.job && `${person.job} at ${person.workplace}`}
                    {person && person.team && `${person.team}`}
                </p>
            </div>
        </div>
    )
}
export default Card;